import constants from './constants';
import chartUtils from '../utils/chart-utils';

var SolidGaugeChartYAxis = {
    lineWidth: 0,
    minorTickInterval: null,
    tickAmount: 0,
    labels: {},
    min: 0,
    max: {}
};

var configureSolidGaugeYAxis = function configureSolidGaugeYAxis(widgetConfig, seriesDataObj) {
    var GaugeConfig = widgetConfig.GaugeConfig;


    if (GaugeConfig && GaugeConfig.GaugeType.toLowerCase() === constants.chartTypes.SOLIDGAUGE) {
        var firstValue = GaugeConfig.ThresholdField1 / 100;
        var secondValue = GaugeConfig.ThresholdField2 / 100;
        var COLOR_DIFFERENTIATOR = 0.1;
        var listOfValue = [firstValue, secondValue, 1];
        var Color = GaugeConfig.Color,
            Color2 = GaugeConfig.Color2,
            Color3 = GaugeConfig.Color3;

        var listOfColor = [Color, Color2, Color3];
        var ValueFormat = GaugeConfig.ValueFormat,
            CurrencySymbol = GaugeConfig.CurrencySymbol,
            BaseFormat = GaugeConfig.BaseFormat;


        SolidGaugeChartYAxis.stops = [];
        SolidGaugeChartYAxis.stops.push([listOfValue[0], listOfColor[0]]);
        SolidGaugeChartYAxis.stops.push([listOfValue[1] - COLOR_DIFFERENTIATOR, listOfColor[0]]);
        SolidGaugeChartYAxis.stops.push([listOfValue[1], listOfColor[1]]);
        SolidGaugeChartYAxis.stops.push([listOfValue[2] - COLOR_DIFFERENTIATOR, listOfColor[1]]);
        SolidGaugeChartYAxis.stops.push([listOfValue[2], listOfColor[2]]);
        if (widgetConfig.GaugeConfig.MaxRange || widgetConfig.GaugeConfig.MaxValueField && widgetConfig.GaugeConfig.MaxValueField !== "--") SolidGaugeChartYAxis.max = widgetConfig.GaugeConfig.MaxRange > 0 ? widgetConfig.GaugeConfig.MaxRange : seriesDataObj[0][widgetConfig.GaugeConfig.MaxValueField];else SolidGaugeChartYAxis.max = 2 * seriesDataObj[0][widgetConfig.GaugeConfig.ValueField];
        SolidGaugeChartYAxis.labels = {
            y: 20,
            style: {
                "font-size": "15px"
            },
            formatter: function formatter() {
                return chartUtils.format(this.value, ValueFormat, CurrencySymbol, null, BaseFormat);
            }
        };
    }
    return SolidGaugeChartYAxis;
};

export default configureSolidGaugeYAxis;